import { Select } from '@components/Select/Select';
import { useAppTranslation } from '@hooks/useAppTranslation';
import {
  languageConfigs,
  SupportedLanguage,
  supportedLanguages,
} from '@store/i18n';

/**
 * Language selection component that displays a dropdown of supported languages.
 * Uses the generic Select component for consistency and reusability.
 */
export function LanguageSelect(): React.ReactNode {
  const { language, setLanguage, t } = useAppTranslation();

  const options = supportedLanguages.map((lang: SupportedLanguage) => ({
    value: lang,
    label: languageConfigs[lang].name,
  }));

  return (
    <Select
      options={options}
      value={language}
      onValueChange={(value) => setLanguage(value as SupportedLanguage)}
      placeholder={t('profile.selectLanguage')}
    />
  );
}
